import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the AppPopupEvaluationMailSentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-popup-evaluation-mail-sent',
  templateUrl: 'app-popup-evaluation-mail-sent.html',
})
export class AppPopupEvaluationMailSentPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPopupEvaluationMailSentPage');

  }
  saveData() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-popup-evaluation-mail-sent/app-popup-evaluation-mail-sent.ts